import {handleLogout} from "components/utils"; import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Col, Form, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {VerticalTimelineElement} from 'react-vertical-timeline-component';
import {DiagnosticsVisitView} from "../../../diagnostics/DiagnosticsVisitView";


export const RecordView = (props: { uhid: string, cookieEntityQr: string, data: any, reloadMethod: any, caseStatus: string, referringDr : string }) => {

    const [record, setRecord] = useState(null);
    useEffect(() => {
        if (props.data) {
            axios.get('/api/backend/customer/records/fetch/id/' + props.data.medicalRecordId)
                .then(resp => {
                    console.log(JSON.stringify(resp.data))
                    setRecord(resp.data)
                })
                .catch(err => {
                    console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
                })
        }

    }, [props.data])

    const handleDeleteRecordModal = () => {
        axios.get('/api/backend/ipd/case/audit/remove/' + props.data.id)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                props.reloadMethod()
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    return (
        <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{background: '#ebecff', color: 'black'}}
            contentArrowStyle={{borderRight: '7px solid  #ebecff'}}
            date={props.data.createdAt + " - " + (props.data.createdByName && props.data.createdByName.split("@")[0])}
            iconStyle={{background: "#ebecff", fontSize: 25, textAlign: "center"}}
            icon="⚕️"
        >
            {props.caseStatus != "CLOSED" && <div className="float-right"><a href="#/" className="text-decoration-none remove font-weight-bold"
                                                onClick={handleDeleteRecordModal}>X</a></div>}
            <div>
                <DiagnosticsVisitView uhid={props.uhid} visitId={props.data.id} entityQr={props.cookieEntityQr}
                                      source={"IPD"}
                                      diagnosticCategory={null} shouldAddNew={false} createVisit={null}/>
            </div>


        </VerticalTimelineElement>
    );
}